import { lazy, Route } from '@tanstack/router'

import { profileRoute } from '.'

const FreeBonus = lazy(() => import('../../pages/profile/free-bonus'))

export type FreeBonusSearch = {
  tab?: 'rescue-bonus' | 'free-play' | 'birthday-gift' | 'friday-pay'
}

export const freeBonusRoute = new Route({
  getParentRoute: () => profileRoute,
  path: 'free-bonus',
  component: FreeBonus,
  validateSearch: (search: Record<string, unknown>): FreeBonusSearch => {
    const tab = search.tab
    if (
      tab === 'rescue-bonus' ||
      tab === 'free-play' ||
      tab === 'birthday-gift' ||
      tab === 'friday-pay'
    ) {
      return { tab }
    }
    return {}
  },
})
